// Item and effect icons drawn in code (decision 0053: icons drawn in code; 0046: UI art in code, in the valley
// palette): an SVG per item look shape in the item's colour, decorative (the row's title names the item).
import { h, type VNode } from "@rpg/ui";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type El = VNode<any>;

/** Each look shape's paths in a 24-unit box (filled in the item's colour, outlined dark). */
const SHAPES: Record<string, string[]> = {
  leaf: ["M4 20C4 10 11 4 20 4c0 9-6 16-16 16z", "M5 19 15 9"],
  flower: ["M12 13a3 3 0 1 0 0-.1z", "M12 3c2 3 2 5 0 7-2-2-2-4 0-7zM21 12c-3 2-5 2-7 0 2-2 4-2 7 0zM12 21c-2-3-2-5 0-7 2 2 2 4 0 7zM3 12c3-2 5-2 7 0-2 2-4 2-7 0z"],
  rock: ["M4 16 7 7l7-3 6 6-2 9-9 1z"],
  plank: ["M3 9h18v6H3z", "M7 11h6"],
  shard: ["M6 20 9 4l9 6-3 10z"],
  dust: ["M8 9a2 2 0 1 0 0-.1zM15 7a2.5 2.5 0 1 0 0-.1zM12 16a3 3 0 1 0 0-.1zM6 17a1.5 1.5 0 1 0 0-.1zM18 15a1.5 1.5 0 1 0 0-.1z"],
  glyph: ["M12 2 21 12 12 22 3 12z", "M12 7v10M8 12h8"],
  bowl: ["M3 11h18c0 5-4 9-9 9s-9-4-9-9z", "M8 8c0-2 2-2 2-4M13 8c0-2 2-2 2-4"],
  bottle: ["M10 3h4v4l3 4v9H7v-9l3-4z", "M9 14h6"],
  charm: ["M12 5a7 7 0 1 0 0 14 7 7 0 1 0 0-14z", "M12 2v3M12 9l2 3-2 3-2-3z"],
  staff: ["M6 21 17 6", "M17 6a3 3 0 1 0 0-.1z"],
  sword: ["M5 19 17 5l2 2-12 12z", "M4 16l4 4M3 21l2-2"],
  wand: ["M5 20 15 10", "M17 4l1 3 3 1-3 1-1 3-1-3-3-1 3-1z"],
};

/** An item's icon: its look shape in its colour (decorative: hidden from assistive tech). */
export function ItemIcon(p: { shape: string; colour: string }): El {
  const paths = SHAPES[p.shape] ?? SHAPES.rock!;
  return h(
    "svg",
    { viewBox: "0 0 24 24", "aria-hidden": "true", focusable: "false" },
    paths.map((d, i) => h("path", { d, fill: i === 0 ? p.colour : "none", stroke: i === 0 ? "#1d2a1f" : p.colour, "stroke-width": i === 0 ? 1.2 : 1.6, "stroke-linejoin": "round", "stroke-linecap": "round" })),
  );
}

/** An effect's icon: a dot in its colour (a burn, a slow, a buff). */
export function EffectIcon(p: { colour: string }): El {
  return h("svg", { viewBox: "0 0 24 24", "aria-hidden": "true", focusable: "false" }, h("circle", { cx: 12, cy: 12, r: 8, fill: p.colour, stroke: "#1d2a1f", "stroke-width": 1.5 }));
}
